export const CloudFunctionNames = {
    acceptProjectInvite: "acceptProjectInviteV2",
    adminCloneDocument: "adminCloneDocumentV2",
    algoliaAuth: "algoliaAuthV2",
    getDatasheetUrl: "getDatasheetUrlV2",
    cloneDocument: "cloudCloneDocumentV2",
    copyActionRecords: "copyActionRecordsV2",
    createApiKey: "createApiKeyV2",
    createAutoLayoutJob: "createAutoLayoutJobV2",
    createLead: "createLeadV2",
    createStripeCheckoutLink: "createStripeCheckoutLinkV2",
    createStripePortalLink: "createStripePortalLinkV2",
    doCreateProjectChatFromClient: "doCreateProjectChatFromClientV2",
    fetchSKUs: "fetchSKUsV2",
    findEnterpriseOrganization: "findEnterpriseOrganizationV2",
    fluxAuth: "fluxAuthV2",
    getCreditReport: "getCreditReportV2",
    getAdminCreditReport: "getAdminCreditReportV2",
    getAdminCreditTransactions: "getAdminCreditTransactionsV2",
    getAdminStripeCustomerId: "getAdminStripeCustomerIdV2",
    giveConsentForPaidCredits: "giveConsentForPaidCreditsV2",
    snoozePaidCreditConsent: "snoozePaidCreditConsentV2",
    getPresignedUrl: "getPresignedUrlV2",
    getProjectName: "getProjectNameV2",
    getProjectUidForUrl: "getProjectUidForUrlV2",
    getProjectUidForUrlAdmin: "getProjectUidForUrlAdminV2",
    getProjectUsage: "getProjectUsageV2",
    getSharedWorkspaces: "getSharedWorkspacesV2",
    reactivateTrial: "reactivateTrialV2",
    renameProject: "renameProjectV2",
    reportCopilotChatIssue: "reportCopilotChatIssueV2",
    requestDocumentPricingRefresh: "requestDocumentPricingRefreshV2",
    requestPricingCacheUpdate: "requestPricingCacheUpdateV2",
    requestPricingDataRefresh: "requestPricingDataRefreshV2",
    restoreProject: "restoreProjectV2",
    restoreProjectToNewFromVersion: "restoreProjectToNewFromVersionV2",
    reconstructProject: "reconstructProjectV2",
    retrieveAuditLogForMessage: "doRetrieveAuditLogForMessageV2",
    schemaVersion: "schemaVersionV2",
    searchDistributors: "searchDistributorsV2",
    sendAddUserRoleEmail: "sendAddUserRoleEmailV2",
    sendPasswordResetLink: "sendPasswordResetLinkV2",
    sendProjectInviteEmail: "sendProjectInviteEmailV2",
    sendVerificationEmail: "sendVerificationEmailV2",
    setCreditSpendingLimit: "setCreditSpendingLimitV2",
    updateThreadBriefState: "updateThreadBriefStateV2",
    clearBriefPlan: "clearBriefPlanV2",
    shadowban: "shadowbanV2",
    startEtlJobForPart: "startEtlJobForPartV2",
    startExtractOrderingInformationJob: "startExtractOrderingInformationJobV2",
    startImportDatasheetComponentJob: "startImportDatasheetComponentJobV2",
    startPdfEtlJob: "startPdfEtlJobV2",
    testFunction: "testFunctionV2",
    testPubSubOnPublish: "testPubSubOnPublishV2",
    testPubSubOnRun: "testPubSubOnRunV2",
    testTaskQueueOnDispatch: "testTaskQueueOnDispatchV2",
    testFirestoreOnWrite: "testFirestoreOnWriteV2",
    testFirestoreOnCreate: "testFirestoreOnCreateV2",
    testCloudStorageOnFinalize: "testCloudStorageOnFinalizeV2",
    triggerDesignReview: "triggerDesignReviewV2",
    typesenseAdminAuth: "typesenseAdminAuthV2",
    typesenseAuth: "typesenseAuthV2",
    updateAccountFollowingState: "updateAccountFollowingStateV2",
    uploadFileForComment: "doUploadFileForCommentV2",
    createEducationalPlanCheckout: "createEducationalPlanCheckoutV2",
    verifyEmailAddress: "verifyEmailAddressV2",
    writeUserPresence: "writeUserPresenceV2",
    saveDocumentSnapshot: "saveDocumentSnapshotV2",
    retryMessageGeneration: "doRetryMessageGenerationV2",
    triggerCopilotActionGeneration: "triggerCopilotActionGenerationV2",
    searchSystemKnowledgeModerationQueue: "searchSystemKnowledgeModerationQueueV2",
    searchSystemKnowledgeBase: "searchSystemKnowledgeBaseV2",
    evaluateChatThreadSatisfaction: "evaluateChatThreadSatisfactionV2",
    classifyNets: "classifyNetsV2",
    setAdminFreeCredits: "setAdminFreeCreditsV2",
    userSoftDeleteAdmin: "userSoftDeleteAdminV2",
    educationalQualificationAdmin: "educationalQualificationAdminV2",
    sandbox: "sandboxV2",
    generateCss: "generateCssV2",
    migrateUserToLatestOnboardingState: "migrateUserToLatestOnboardingStateV2",
    endTrialEarly: "endTrialEarlyV2",
};
//# sourceMappingURL=constants.js.map